<div class="dialog-title">
  <h3>Set Approved States</h3>
  <p>Select the states this user is approved to access.</p>
</div>

<mat-dialog-content class="dialog-content">
  @if (isLoading()) {
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  } @else if (loadFailed()) {
  <p class="error-message">
    Failed to load current approved states. Please close and try again.
  </p>
  } @else {
  <form>
    @for (request of stateRequest(); track request.id) {
    <div class="flex-row">
      <div class="column-layout fill">
        <div class="state-name">{{ request.stateName }}</div>
        <small class="request-info">{{ request.reason }}</small>
      </div>
      <button mat-button type="button" color="primary" (click)="approveRequest(request)">Approve</button>
      <button mat-button color="warn" type="button" [matMenuTriggerFor]="denyMenu" #denyTrigger="matMenuTrigger"
        (click)="openDenyMenu()">Deny</button>

      <mat-menu #denyMenu="matMenu" [overlapTrigger]="false" class="deny-menu-panel">
        <div (click)="$event.stopPropagation()" tabindex="0" (keypress.enter)="$event.stopPropagation()"
          class="deny-popover-content">
          <p class="deny-popover-title">Denial reason for '{{ request.stateName }}'</p>
          <mat-form-field appearance="outline">
            <mat-label>Reason</mat-label>
             <textarea matInput [formControl]="denialReasonControl"
                       cdkTextareaAutosize
                       cdkAutosizeMinRows="3"
                       cdkAutosizeMaxRows="3"
            ></textarea>
          </mat-form-field>
          <div class="deny-popover-actions">
            <button mat-button (click)="denyTrigger.closeMenu()">Cancel</button>
            <button mat-button color="warn" [disabled]="!denialReasonControl.value"
              (click)="denyRequest(request, denialReasonControl.value!); denyTrigger.closeMenu()">
              Deny
            </button>
          </div>
        </div>
      </mat-menu>
    </div>
    <mat-divider></mat-divider>
    }

    <mat-form-field class="wide" appearance="outline">
      <mat-label>Add State/Territory</mat-label>
      <input type="text" matInput [formControl]="filterControl" [matAutocomplete]="autoComplete" />
      <mat-autocomplete #autoComplete="matAutocomplete" (optionSelected)="addState($event)" [displayWith]="displayFn">
        @for (territory of filteredTerritories$ | async; track territory.id) {
        <mat-option [value]="territory">{{ territory.name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>

  <mat-chip-set class="chip-set">
    @for (state of selectedStates | async; track state.id) {
    <mat-chip (removed)="removeState(state)">
      {{ state.name }}
      <button matChipRemove [attr.aria-label]="'Remove ' + state.name">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
    }
    @if ((selectedStates | async)?.length === 0) {
    <mat-hint class="no-states">No approved states selected.</mat-hint>
    }
  </mat-chip-set>

  @if (saveError()) {
  <p class="error-message">
    Failed to save approved states. Please try again.
  </p>
  }
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button (click)="cancel()" cdkFocusInitial>Cancel</button>
  <button mat-flat-button color="primary" (click)="submit()" [disabled]="isLoading() || loadFailed() || isSaving()">
    Set Approved States
  </button>
</mat-dialog-actions>
